module.exports = __webpack_public_path__ + "static/media/il.8c2a3212.svg";